import React from "react";

import { MetaTags } from "react-meta-tags";
import {
  Breadcrumbs,
  DashBreadcrumb,
} from "../../components/Common/Breadcrumb";
//../../../components/Common/Breadcrumb
import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

import ListReturnComponent from "./components/StoreSelection/ListReturn.component";
import QueueExportReport from "./components/QueueExportReport";
import { EXPORT_ALLOWED_USER_ROLES } from "../../constants";
const ManageQueueReturn = () => {
  const title = "Queue Return List";
  const description = "Queue Return List";
  const users = JSON.parse(localStorage?.getItem('authUser'));
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Return Request</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="Queue List" breadcrumbItem="Manage Return Request" />
            </Col>
            <Col>
              {EXPORT_ALLOWED_USER_ROLES.includes(users?.role_id) ? (
                <QueueExportReport users={users} type="return" exportType="Return requests" />
              ) : (
                ''
              )}
            </Col>
          </Row>
         <ListReturnComponent></ListReturnComponent>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ManageQueueReturn;
